/**
 * GET `admin/reports/clinics/:id/revenue` — динамика выручки клиники.
 * Шаг ряда подбираем по периоду: 7d/1m — по дням, 3m/all — по месяцам.
 */

import {apiEnabled, http} from '@services/utils';

import {MOCK_REVENUE_POINTS} from '../mocks';
import {arr, asObj, asStr, type Raw, toSom} from '../raw.utils';
import type {ReportPeriod, RevenuePoint} from '../types';

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export const revenueGroupBy = (period: ReportPeriod): 'day' | 'month' =>
  period === '7d' || period === '1m' ? 'day' : 'month';

export const getClinicRevenue = async (
  clinicId: string,
  period: ReportPeriod,
): Promise<RevenuePoint[]> => {
  if (!apiEnabled) {
    await sleep(320);
    return MOCK_REVENUE_POINTS.map((p) => ({...p}));
  }

  const raw = await http<Raw>(`admin/reports/clinics/${encodeURIComponent(clinicId)}/revenue`, {
    params: {period, groupBy: revenueGroupBy(period)},
    skipCaseConversion: true,
  });
  return arr(raw.points).map((v) => {
    const r = asObj(v);
    return {
      bucket: asStr(r.bucket),
      income: toSom(r.incomeTiyin),
      refund: toSom(r.refundTiyin),
      net: toSom(r.netTiyin),
    };
  });
};
